import { Icon } from '@paysera/ui';
import CreditScoreHeader from '@modules/investor/components/common/CreditScoreHeader';
import { getOpportunityRows } from '@modules/investor/utils/getOpportunityRows';
import { mapOpportunitiesToColumns } from '@modules/investor/utils/mapOpportunitiesToColumns';
export const createOpportunitiesTableConfig = (t) => {
    const getDetailsColumn = () => (<div className="flex justify-center w-full">
            <Icon name="chevron_forward" size="sm"/>
        </div>);
    const columns = [
        {
            header: t('financing.investing_page_table.id'),
            accessorKey: 'id',
            size: 56,
            sortable: true,
        },
        {
            header: t('financing.investing_page_table.investment_deadline'),
            accessorKey: 'investmentDeadline',
            sortable: true,
        },
        {
            header: t('financing.investing_page_table.asked_amount'),
            accessorKey: 'loanAmount',
            sortable: true,
        },
        {
            header: t('financing.investing_page_table.loan_purpose'),
            accessorKey: 'loanPurpose',
        },
        {
            header: t('financing.investing_page_table.period'),
            accessorKey: 'loanPeriod',
            sortable: true,
        },
        {
            header: t('financing.investing_page_table.roi'),
            accessorKey: 'roi',
        },
        {
            header: () => <CreditScoreHeader />,
            accessorKey: 'riskScore',
            sortable: true,
        },
        {
            header: t('financing.investing_page_table.funding_progress'),
            accessorKey: 'fundingProgress',
        },
        {
            header: '',
            accessorKey: 'details',
            cell: getDetailsColumn,
            size: 68,
        },
    ];
    return {
        columns,
        mapDataToColumns: mapOpportunitiesToColumns,
        getMobileRows: getOpportunityRows,
        isInvestment: false,
    };
};
